"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobiles_json_1 = __importDefault(require("../../fixtures/regexes/device/mobiles.json"));
const variable_replacement_1 = require("../../utils/variable-replacement");
const user_agent_1 = require("../../utils/user-agent");
const model_1 = require("../../utils/model");
class MobileParser {
    constructor() {
        this.parse = (userAgent) => {
            const result = {
                type: "",
                brand: "",
                model: ""
            };
            for (const [brand, mobile] of Object.entries(mobiles_json_1.default)) {
                const match = user_agent_1.userAgentParser(mobile.regex, userAgent);
                if (!match)
                    continue;
                result.type = mobile.device || "";
                result.brand = brand;
                if (mobile.model) {
                    result.model = model_1.buildModel(variable_replacement_1.variableReplacement(mobile.model, match)).trim();
                }
                else if (mobile.models) {
                    for (const model of mobile.models) {
                        const modelMatch = user_agent_1.userAgentParser(model.regex, userAgent);
                        if (!modelMatch)
                            continue;
                        result.model = model_1.buildModel(variable_replacement_1.variableReplacement(model.model, modelMatch)).trim();
                        if (model.device) {
                            result.type = model.device;
                        }
                        if ("brand" in model) {
                            result.brand = model.brand || "";
                        }
                        break;
                    }
                }
                break;
            }
            // Sanitize device type
            if (result.type === "tv") {
                result.type = "television";
            }
            if (result.type === "car browser") {
                result.type = "car";
            }
            // Sanitize device brand
            if (result.brand === "Unknown") {
                result.brand = "";
            }
            return result;
        };
    }
}
exports.default = MobileParser;



//////////////////
// WEBPACK FOOTER
// ./~/device-detector-js/dist/parsers/device/mobiles.js
// module id = 884
// module chunks = 113